<template>
  <div>
    <modal
      name="audio-upload"
      width="80%"
      height="auto"
      style="overflow-y: scroll"
    >
      <div class="row">
        <div class="col-6">
          <div class="card">
            <div class="card-header bg-primary text-white">Hochladen</div>
            <div class="card-body" style="text-align: center;">
              <i class="fas fa-upload fa-5x" @click="uploadFromDevice()"></i>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="card">
            <div class="card-header bg-primary text-white">Aufnahme</div>
            <div class="card-body" style="text-align: center;">
              <i
                class="fas fa-microphone fa-5x"
                @click="
                  $modal.hide('audio-upload');
                  $modal.show('audio-record');
                  initRecorder();
                "
              ></i>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <modal
      name="audio-record"
      width="40%"
      height="auto"
      style="overflow-y: scroll;"
    >
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header bg-primary text-white">
              Sprachnachricht aufnehmen
            </div>
            <div class="card-body">
              <div v-if="recordStage == 0" class="text-primary">
                Bitte gestatten Sie Ihrem Browser Zugriff auf Ihr Mikrofon, um
                mit der Aufnahme beginnen zu können.
              </div>
              <div v-if="recordStage == 1">
                <button @click="startRecording()" class="btn btn-primary">
                  <i class="fas fa-circle"></i>
                  Aufnahme starten
                </button>
              </div>
              <div class="row" v-if="recordStage == 2">
                <div class="col-6">
                  <button @click="stopRecording()" class="btn btn-primary">
                    <i class="fas fa-stop"></i>
                    Aufnahme beenden
                  </button>
                </div>
                <div class="col-6 text-primary">{{ recordText }}</div>
              </div>
              <div>
                <div
                  v-if="recordStage >= 3"
                  class="row align-items-center justify-content-around"
                >
                  <audio id="player" controls></audio>
                </div>
                <hr v-if="recordStage >= 3" />
                <div v-if="recordStage == 3" class="row">
                  <div class="col-6" style="text-align: center;">
                    <button @click="recordAgain()" class="btn btn-primary">
                      <i class="fas fa-trash-alt"></i>
                      Verwerfen
                    </button>
                  </div>
                  <div class="col-6" style="text-align: center;">
                    <button @click="acceptAudio()" class="btn btn-primary">
                      <i class="fas fa-check-circle"></i>
                      Hochladen
                    </button>
                  </div>
                </div>
                <div
                  v-if="recordStage == 4"
                  class="row text-primary align-items-center justify-content-around"
                >
                  <i class="fas fa-spinner fa-spin fa-2x"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <button class="btn btn-primary w-100" @click="$modal.show('audio-upload')">
      Sprachnachricht hochladen
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      recordStage: 0, // 0: mic not detected, 1: ready to record, 2: recording, 3: record complete, 4: uploading
      recorder: null,
      audioChunks: [],
      audioFile: null,
      mediaRecorder: null,
      recordText: "Aufnehmen",
      dots: 1,
      successMessage:
        "Dein Medium wurde erfolgreich hochgeladen und wird geprüft."
    };
  },
  props: {
    media_update_url: {
      required: true,
      type: String
    }
  },
  mounted() {
    setInterval(this.countDots, 400);
  },
  methods: {
    initRecorder() {
      if (this.mediaRecorder === null) {
        new Promise(async () => {
          const stream = await navigator.mediaDevices
            .getUserMedia({
              audio: true
            })
            .catch(() => {
              this.$notify({
                title:
                  "Bitte gestatten Sie Ihrem Browser Zugriff auf Ihr Mikrofon, um mit der Aufnahme beginnen zu können.",
                type: "error"
              });
            });
          if (stream == undefined) {
            return;
          }
          this.mediaRecorder = new MediaRecorder(stream, {
            mimeType: "audio/webm"
          });
          this.mediaRecorder.addEventListener("dataavailable", event => {
            this.audioChunks.push(event.data);
          });

          this.recordStage = 1;
        });
      } else {
        if (this.recordStage == 2) {
          this.mediaRecorder.stop();
        }
        this.recordStage = 1;
      }
    },
    startRecording() {
      if (this.recordStage == 1) {
        this.audioChunks = [];
        this.mediaRecorder.start();

        this.recordStage = 2;
      }
    },
    stopRecording() {
      if (this.recordStage == 2) {
        new Promise(resolve => {
          this.mediaRecorder.addEventListener("stop", () => {
            this.audioFile = new Blob(this.audioChunks, { type: "audio/webm" });

            document.getElementById("player").src = URL.createObjectURL(
              this.audioFile
            );

            resolve();
          });

          this.recordStage = 3;

          this.mediaRecorder.stop();
        });
      }
    },
    recordAgain() {
      if (this.recordStage > 2) {
        this.recordStage = 1;
      }
    },
    acceptAudio() {
      // Upload audio file to the server, close modal when upload is complete
      this.recordStage = 4;

      const formdata = new FormData();
      formdata.append("file", this.audioFile);

      this.$store.dispatch("uploadProgress/uploadMedia", {
        url: this.media_update_url,
        data: formdata,
        meta: [formdata.get("file").type, formdata.get("file").size],
        successMessage: this.successMessage
      });

      let error = this.$store.getters["uploadProgress/error"];
      if (error) {
        this.recordStage = 3;
        this.$modal.show("audio-record");
      }
    },
    countDots() {
      this.dots++;
      if (this.dots > 3) this.dots = 0;

      this.recordText = "Aufnehmen";
      for (let i = 0; i < this.dots; i++) {
        this.recordText += ".";
      }
    },
    uploadFromDevice() {
      var input = document.createElement("input");
      input.type = "file";
      input.accept = "audio/*";

      input.addEventListener("change", () => {
        if (input.files.length == 1) {
          const formdata = new FormData();
          formdata.append("file", input.files[0]);
          this.$store.dispatch("uploadProgress/uploadMedia", {
            url: this.media_update_url,
            data: formdata,
            meta: [formdata.get("file").type, formdata.get("file").size],
            successMessage: this.successMessage
          });
        }
      });

      input.click();
    }
  }
};
</script>
